import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogSpeedTimelines() {
  useEffect(() => {
    document.title = 'Shortening Lead Time: How Professional Layouts Speed Up Project Timelines | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Time is money. A 24-hour delay on a pour can cost thousands. Learn how professional CAD layouts with 24-48 hour turnaround keep crews working instead of waiting on Vancouver construction sites.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'fast construction layout quotes, reducing construction delays, professional CAD drafting Vancouver, quick turnaround formwork, construction efficiency');
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Shortening the Lead Time: How Professional Layouts Speed Up Project Timelines',
      description: 'Time is money. A 24-hour delay on a pour can cost thousands. Learn how professional CAD layouts with 24-48 hour turnaround keep crews working.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2024-03-25',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-speed"]')) {
      script.setAttribute('data-schema', 'blog-speed');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-speed"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
